module.exports = __webpack_public_path__ + "static/WEDDING E&M-159-8e5b62853ee35fc5fd7f745eb3d6a7b7.jpg";